import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { TApi } from 'utils/api';
import { measurementAtom } from '../store/measurement';

import { ENDPOINTS } from '../consts/endpoints';

type TResult = {
  isLoading: boolean;
  isAvailable: boolean;
};

type TParams = {
  serviceId: string;
  regionId?: string;
  api?: TApi;
};

export const useMeasurement = ({ serviceId, regionId, api }: TParams): TResult => {
  const [measurement, setMeasurementState] = useRecoilState(measurementAtom);

  useEffect(() => {
    if (!__IS_SERVER__ && regionId && api) {
      api
        .get(ENDPOINTS.GET_SERVICE({ serviceId, regionId }), {})
        .then(res => {
          setMeasurementState(prevState => ({
            ...prevState,
            ...res,
            isLoaded: true,
          }));
        })
        .catch(() => {
          setMeasurementState(prevState => ({
            ...prevState,
            isLoaded: true,
            isError: true,
          }));
        });
    }
  }, [api, regionId, serviceId, setMeasurementState]);

  return {
    isLoading: !measurement.isLoaded,
    isAvailable: measurement.isLoaded && !measurement.isError,
  };
};
